import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,
    TextField
} from "@material-ui/core";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import trLocale from 'date-fns/locale/tr';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import {DatePicker} from "@mui/lab";
import {format, isWeekend} from "date-fns";
import SendIcon from '@mui/icons-material/Send';
import IconButton from "@mui/material/IconButton";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
export default function ModalBoxOnayla(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        idd:props.id,
        onay_tarihi:'',
        tur: !!props.tur

    });
    const [siparisNo, setSiparisNo] = useState();


    const handleClickOpen = () => {
        setOpen(true);

    };

    const handleClose = () => {
        setOpen(false);
        setState({'onay_tarihi':''});
    };
    return (
        <div>
            <IconButton variant="outlined" size={"small"} color={'success'} onClick={handleClickOpen }>
                <CheckCircleOutlineIcon />
            </IconButton>
             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">{state.tur ? 'Final İş Emirlerine Gönder' : 'Onaylananlara Gönder' }</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tarih Giriniz
                    </DialogContentText>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                        <DatePicker
                            label="Onay Tarihi"
                            value={state.onay_tarihi}
                            onChange={(newValue) => {
                                setState({'onay_tarihi':newValue});
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    <br/>
                    <TextField
                        style={props.tur ? {display:"none"} : {display:"block"}}
                        margin="dense"
                        id="siparis_kodu"
                        label="Müşteri Sipariş No"
                        type="text"
                        value={siparisNo || ""}
                        onChange={(event) => {
                             setSiparisNo(event.target.value)
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button

                        onClick={

                            async () => {
                                !props.tur ?
                             await api.post('/teklifler/' + props.teklifNo + '/onayla', {

                                 'onay_tarihi': state.onay_tarihi
                                     ? format(state.onay_tarihi, 'yyyy-MM-dd')
                                     : null,
                                 'siparis_no':siparisNo

                             })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.onaylananlara();
                                    window.location.reload();
                                 })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                }) :
                                // iş emirleri için

                                    await api.post('/is-emirleri/' + props.is_emri_no + '/onayla', {
                                        'onay_tarihi': state.onay_tarihi,
                                    })
                                        .then((response) => {
                                            // Success 🎉
                                            console.log(response);
                                            handleClose();
                                            props.onaylananlara();
                                            window.location.reload()
                                        })
                                        .catch((error) => {
                                            // Error 😨
                                            if (error.response) {
                                                /*
                                                 * The request was made and the server responded with a
                                                 * status code that falls out of the range of 2xx
                                                 */
                                                console.log(error.response.data);
                                                console.log(error.response.status);
                                                console.log(error.response.headers);
                                            } else if (error.request) {
                                                /*
                                                 * The request was made but no response was received, `error.request`
                                                 * is an instance of XMLHttpRequest in the browser and an instance
                                                 * of http.ClientRequest in Node.js
                                                 */
                                                console.log(error.request);
                                            } else {
                                                // Something happened in setting up the request and triggered an Error
                                                console.log('Error', error.message);
                                            }
                                            console.log(error.config);
                                        }) ;
                                setOpen(false);
                        }}
                        color="primary"
                    >
                        Gönder
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

